export default class TacticsChange {
    get(frame) {
        if(frame.ZT != null) {
            return [frame.num - 1, frame.num + 5, 5]

        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/episods/all/tactics_change.js
 **/